import { jsx } from 'react/jsx-runtime';
import { Progress } from '@backstage/core-components';
import { lazy, Suspense } from 'react';

const LazyGraphQlDefinition = lazy(
  () => import('./GraphQlDefinition.esm.js').then((m) => ({
    default: m.GraphQlDefinition
  }))
);
const GraphQlDefinitionWidget = (props) => {
  return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Progress, {}), children: /* @__PURE__ */ jsx(LazyGraphQlDefinition, { ...props }) });
};

export { GraphQlDefinitionWidget };
//# sourceMappingURL=GraphQlDefinitionWidget.esm.js.map
